import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { saveAs } from 'file-saver-es';
import { filter, Subscription } from 'rxjs';
import { ControlsModule } from 'segov-sigepo-lib';
import { DadosArquivoServicoOutputDto } from 'src/app/domain/DTOs/output/servicos/dados-arquivo-servico-output-dto';
import { ServicoOutputDto } from 'src/app/domain/DTOs/output/servicos/servico.output.dto';
import { TopicoArquivosOutputDto } from 'src/app/domain/DTOs/output/servicos/topico-arquivos.output.dto';
import { TopicoOutputDto } from 'src/app/domain/DTOs/output/servicos/topico.output.dto';
import { obterArquivoServico, obterArquivoServicoFinish } from 'src/app/stateManagement/actions/Servicos/obter-arquivo-servico-jornal.action';
import { listarServicos, listarServicosFinish } from 'src/app/stateManagement/actions/Servicos/servico-jornal.action';
import { ObterArquivoServicoState } from 'src/app/stateManagement/reducers/Servicos/obter-arquivo-servico-jornal.reducer';
import { ListarServicosState } from 'src/app/stateManagement/reducers/Servicos/servicos-jornal.reducer';
import { selectDadosObterArquivoServico, selectErrosObterArquivoServico } from 'src/app/stateManagement/selectors/Servicos/obter-arquivo-servico-jornal.selector';
import { selectDadosListarServicos } from 'src/app/stateManagement/selectors/Servicos/servicos-jornal.selector';
import { DictReverseOrderPipe } from 'src/app/utils/pipes/dict-reverse-order.pipe';
import { StringUtils } from 'src/app/utils/string.utils';
import { SafeHtmlPipe } from 'src/app/utils/pipes/safe-html.pipe';
import { ToastState } from 'src/app/stateManagement/reducers/toast.reducer';
import { toastShow } from 'src/app/stateManagement/actions/toast.action';
import { CommonMessages } from 'src/app/utils/common.messages';
import { ToastModel, ToastType } from 'src/app/domain/models/toast.model';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-listar-topicos-servico',
  standalone: true,
  imports: [
    ControlsModule,
    DictReverseOrderPipe,
    SafeHtmlPipe
  ],
  templateUrl: './listar-topicos-servico.component.html',
  styleUrls: ['./listar-topicos-servico.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListarTopicosServicoComponent implements OnInit, OnDestroy, OnChanges {
  @Input() servicoSelecionado!: string;
  @Input() public accordeonsExpandidos = false;

  public navigateFragment = '';
  public ServicosOutputDto: ServicoOutputDto[] = [];
  public ServicoExibido?: ServicoOutputDto
  private subServico: Subscription;
  private subs: Subscription[];

  private tituloArquivo?: string;

  constructor(
    private route: ActivatedRoute,
    private readonly storeListarServicos: Store<{ listarServicos: ListarServicosState }>,
    private storeToast: Store<{ toastState: ToastState }>,
    private readonly storeObterArquivoServico: Store<{ obterArquivoState: ObterArquivoServicoState }>,
  ) {
    this.subServico = new Subscription();
    this.subs = [];
  }

  ngOnInit(): void {
    this.subServico = this.storeListarServicos.select(selectDadosListarServicos)
      .subscribe(result => {
        if (result?.dados) {
          this.ServicosOutputDto = result?.dados.map(x => ({
            servico: x.servico,
            listaTopicos: x.listaTopicos.map(y => ({
              titulo: y.titulo,
              descricoes: y.descricoes,
              subTopicos: y.subTopicos ?? [],
              exibirTodosAccordions: false
            })),
            listaTopicosArquivos: x.listaTopicosArquivos?.map(y => ({
              titulo: y.titulo,
              descricoes: y.descricoes,
              listaNomeArquivos: y.listaNomeArquivos,
              incluirDescricaoNoAccordeon: y.incluirDescricaoNoAccordeon,
              exibirTodosAccordions: false
            }))
          }))
            ?? [];
        }
        this.atualizaServicoExibido();

        this.route.fragment.subscribe(fragment => {
          if (fragment) {
            setTimeout(() => {
              this.navigateFragment = fragment;
              const elemento = document.getElementById(fragment);
              if (elemento) {
                elemento.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }
        });
      });

    this.subs.push(this.storeObterArquivoServico.select(selectDadosObterArquivoServico)
      .subscribe(result => {
        this.baixarArquivo(result?.dados);
      }));

    this.subs.push(this.storeObterArquivoServico.select(selectErrosObterArquivoServico)
      .pipe(filter(state => state !== null))
      .subscribe((erros) => {
        if (erros)
          this.storeToast.dispatch(toastShow({ toastModel: new ToastModel(CommonMessages.Error, erros.join(";"), ToastType.Warning) }));
      }));

    this.getListarServico();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["servicoSelecionado"] && changes["servicoSelecionado"].previousValue != changes["servicoSelecionado"].currentValue)
      this.atualizaServicoExibido();
  }

  ngOnDestroy(): void {
    this.subServico.unsubscribe();
    this.subs.forEach(x => x.unsubscribe());

    this.storeListarServicos.dispatch(listarServicosFinish());
    this.storeObterArquivoServico.dispatch(obterArquivoServicoFinish());
  }


  public baixarArquivoSelecionado(arquivo: DadosArquivoServicoOutputDto) {
    this.getObterArquivoServico(arquivo);
  }

  public abrirAccordionsSecao($event: TopicoOutputDto | TopicoArquivosOutputDto) {
    this.navigateFragment = '';
    $event.exibirTodosAccordions = !$event.exibirTodosAccordions;
  }

  public abrirAccordionsSecaoEDownload(topico: TopicoOutputDto, agrupamentoArquivos?: TopicoArquivosOutputDto) {
    this.navigateFragment = '';
    if (agrupamentoArquivos)
      agrupamentoArquivos.exibirTodosAccordions = !agrupamentoArquivos.exibirTodosAccordions;
    topico.exibirTodosAccordions = !topico.exibirTodosAccordions;
  }

  public obterLengthDict(agrupamentoArquivos: TopicoArquivosOutputDto) {
    return Object.keys(agrupamentoArquivos.listaNomeArquivos ?? []).length
  }

  private baixarArquivo(base64?: string) {
    if (base64) {
      const download = StringUtils.PrepareFileToDownload(base64);
      saveAs(download.file, `${this.tituloArquivo}.${download.extension}`);
    }
  }

  private getListarServico() {
    this.storeListarServicos.dispatch(listarServicos())
  }

  private getObterArquivoServico(arquivo: DadosArquivoServicoOutputDto) {
    this.tituloArquivo = arquivo.titulo;
    const nomeArquivo = arquivo.nomeArquivo;
    this.storeObterArquivoServico.dispatch(obterArquivoServico({ nomeArquivo }));
  }

  private atualizaServicoExibido() {
    this.ServicoExibido = this.ServicosOutputDto.find(x => x.servico == this.servicoSelecionado);
  }
}
